import { queryOptions } from "@tanstack/react-query";
import { apiClient } from "@/lib/api";
import { publicBranchListSchema } from "../schemas/branches.schemas";

export const branchKeys = {
  all: ["public-branches"] as const,
};

/** The salon's open branches, oldest first, for the picker (FR-SA-244). Anonymous. */
export const publicBranchesQuery = () =>
  queryOptions({
    queryKey: branchKeys.all,
    queryFn: ({ signal }) => apiClient.get(publicBranchListSchema, "/api/v1/salon/public/branches", { signal }),
    staleTime: 5 * 60_000,
  });
